import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "src/context";
import { dealerStorage } from "src/utils";

export default () => {
  const { dealerName } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    void logout();
    dealerStorage.clear();
    navigate(`/${dealerName}`);
  }, []);
  return null;
};
